import clsx from 'clsx';
import React, { FunctionComponent } from 'react';

interface IProps {
  status: number;
  className?: string;
}

const ProgressBar: FunctionComponent<IProps> = ({ status, className = '' }) => {
  /**
   * Progress is complete, so turn it off
   */
  if (status === 1) {
    return null;
  }

  return (
    <div
      className={clsx(className, ' h-1 bg-blue-utility transition-width')}
      style={{
        width: `${status * 100}%`,
      }}
    />
  );
};

export default ProgressBar;
